<template>
    <div>
        <div class="card-body">
            <table class="table" v-loading="this.$parentInfo.historyLimit.loading">
                <thead>
                <tr>
                    <th>开始时间</th>
                    <th>结束时间</th>
                    <th>总额度</th>
                    <th>剩余额度</th>
                    <th>操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in orderHeadTeacherLimits">
                    <td>
                        <el-date-picker
                                v-model="item.start_date"
                                size="small"
                                type="date"
                                :clearable="false"
                                value-format="yyyy-MM-dd"
                                placeholder="日期"
                                style="width: 150px"
                                :disabled="item.change">
                        </el-date-picker>
                    </td>
                    <td>
                        <el-date-picker
                                v-model="item.end_date"
                                size="small"
                                type="date"
                                :clearable="false"
                                value-format="yyyy-MM-dd"
                                placeholder="日期"
                                style="width: 150px"
                                :disabled="item.change">
                        </el-date-picker>
                    </td>
                    <td>
                        <el-input v-model="item.money" placeholder="请输入金额" size="small" :disabled="item.change"  style="width: 80px"></el-input>
                    </td>
                    <td>
                        {{item.amount}}
                    </td>
                    <td>
                        <el-button size="mini" @click="handleChangeHeadTeacherLimit(item.id,item)" :disabled="item.change">修改</el-button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "students-list",
        data() {
            return {

            }
        },
        mounted() {
        },
        computed: {
            orderHeadTeacherLimits: function () {
                return this._.orderBy(this.$parentInfo.historyLimit.headTeacherHistoryLimits, 'id','desc');
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleHistoryTeacherLimit();
        },
        methods: {
            handleHistoryTeacherLimit() {
                this.$wApi.send(this.$parentInfo.path, 'get_history', {
                    'headTeacherLimit_id': this.$store.state.modal.data.headTeacherLimit_id,
                    'headTeacher_id': this.$store.state.modal.data.headTeacher_id,
                });
            },
            handleChangeHeadTeacherLimit(id, item) {
                this.$wApi.send(this.$parentInfo.path, 'update_headTeacherLimit',{'id':id,'headTeacherLimit':item})
            },
            closeModal() {
                this.$store.commit('modal',{dialog:''});
            },
        }
    }
</script>

<style scoped>

</style>